export type InquiryDraft = {
  savedAt: string
  flow?: string
  inquiry: Record<string, unknown>
}

const STORAGE_KEY = 'avInquiryDraft'

const getCsrfToken = () => {
  if (typeof document === 'undefined') return ''
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute('content') || ''
}

const apiBase = (import.meta.env.VITE_AV_API_BASE_URL || '/av-api').replace(/\/$/, '')

export const saveInquiryDraft = (draft: InquiryDraft) => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
  } catch (err) {
    console.warn('Failed to store inquiry draft', err)
  }
}

export const loadInquiryDraft = (): InquiryDraft | null => {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return parsed as InquiryDraft
  } catch (err) {
    console.warn('Failed to parse inquiry draft', err)
    return null
  }
}

export const submitInquiryDraft = async (draft: InquiryDraft) => {
  const headers: Record<string, string> = {
    'content-type': 'application/json',
  }
  const csrf = getCsrfToken()
  if (csrf) headers['x-csrf-token'] = csrf

  return fetch(`${apiBase}/api/inquiries`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ inquiry: draft.inquiry }),
  })
}
